import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { googleSession } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { applyUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (sid) {
        try {
          const ref = localStorage.getItem("pv_ref") || undefined;
          const u = await googleSession(sid, ref);
          localStorage.removeItem("pv_ref");
          applyUser(u);
        } catch (err) {
          console.error("Google session exchange failed:", err);
          toast.error("Sign-in could not be completed. Please try again.");
        }
      }
      window.history.replaceState({}, "", "/planner");
      nav("/planner", { replace: true });
    })();
  }, [nav, applyUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0c1311]">
      <div className="flex items-center gap-3 text-stone-300"><Loader2 className="h-5 w-5 animate-spin text-teal-400" /> Signing you in…</div>
    </div>
  );
}
